import { render, staticRenderFns } from "./ModalCreateNcm.vue?vue&type=template&id=317b6b6e&scoped=true"
import script from "./ModalCreateNcm.vue?vue&type=script&lang=js"
export * from "./ModalCreateNcm.vue?vue&type=script&lang=js"
import style0 from "./ModalCreateNcm.vue?vue&type=style&index=0&id=317b6b6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "317b6b6e",
  null
  
)

export default component.exports